export enum RequestStatusV2 {
  new = 'new',
  proposal = 'proposal',
  expired = 'expired',
  updateRequested = 'update_requested'
}
  